import { SERVICE_TYPE } from 'constants/serviceType';
import { ServicePricing } from 'models/task';

export function getServicePricing(
  serviceType: string,
  vehiclePreference: string
): ServicePricing | null {
  const getServiceType = SERVICE_TYPE.find((obj) => {
    return obj.service_type === serviceType;
  });
  let getServicePricing = getServiceType.service_pricing.find((obj) => {
    return obj.is_default === true;
  });
  if (serviceType === 'ftl') {
    getServicePricing = getServiceType.service_pricing.find((obj) => {
      return obj.vehicle_preference === vehiclePreference;
    });
  }
  return getServicePricing || null;
}
